import { render, staticRenderFns } from "./DocumentWorkflowStatus.vue?vue&type=template&id=62c8e374&scoped=true"
import script from "./DocumentWorkflowStatus.vue?vue&type=script&lang=js"
export * from "./DocumentWorkflowStatus.vue?vue&type=script&lang=js"
import style0 from "./DocumentWorkflowStatus.vue?vue&type=style&index=0&id=62c8e374&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c8e374",
  null
  
)

export default component.exports